import { render, staticRenderFns } from "./EmergencyAssessment.vue?vue&type=template&id=676ea961&scoped=true"
import script from "./EmergencyAssessment.vue?vue&type=script&lang=js"
export * from "./EmergencyAssessment.vue?vue&type=script&lang=js"
import style0 from "./EmergencyAssessment.vue?vue&type=style&index=0&id=676ea961&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676ea961",
  null
  
)

export default component.exports